import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { CategoryEffects } from './category.effects';
import { categoryReducer } from './category.reducer';

export const provideCategoryStore = () => [
  provideState('category', categoryReducer),
  provideEffects([CategoryEffects]),
];
